(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ace-mascot-character"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ace-mascot-character')) {
    customElements.define('ace-mascot-character', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.button = this.querySelector('button');
        this.visible = true;
        this.active = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.controller.signal };
        const peekSelector = '.ace-color-home__peek,.ace-extra-peek,.ace-title-peek,.ace-consult-peek,.ace-mascot-guide__art';
        this.isPhotoPeek = Boolean(this.closest(peekSelector));
        this.toggleAttribute('data-peek-idle', this.isPhotoPeek);
        if (this.isPhotoPeek) {
          const peers = Array.from(document.querySelectorAll('ace-mascot-character')).filter(character => character.closest(peekSelector));
          this.style.setProperty('--ace-peek-phase', `${-(peers.indexOf(this) % 7) * .83}s`);
          this.visible = !('IntersectionObserver' in window);
        }
        this.updatePeekMotion = () => {
          const paused = document.documentElement.hasAttribute('data-ace-peek-paused');
          this.toggleAttribute('data-peek-moving', this.isPhotoPeek && this.isConnected && this.visible && !this.active && !paused && !document.hidden && !this.motion.matches);
        };
        if (this.isPhotoPeek) {
          document.addEventListener('ace:peek-motion-change', this.updatePeekMotion, options);
          this.motion.addEventListener('change', this.updatePeekMotion, options);
        }
        this.stopReaction = () => {
          window.clearTimeout(this.timer);
          this.active = false;
          this.removeAttribute('data-active');
          this.updatePeekMotion();
        };
        this.startReaction = () => {
          if (this.active || !this.visible || document.hidden) return;
          this.active = true;
          this.setAttribute('data-active', '');
          this.updatePeekMotion();
          this.timer = window.setTimeout(this.stopReaction, this.motion.matches ? 900 : 1550);
        };
        this.button.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.startReaction();
        }, options);
        this.button.addEventListener('pointerleave', this.stopReaction, options);
        this.button.addEventListener('focus', this.startReaction, options);
        this.button.addEventListener('blur', this.stopReaction, options);
        this.button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.startReaction();
        }, options);
        this.button.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.stopReaction();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopReaction();
          this.updatePeekMotion();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            if (!this.visible) this.stopReaction();
            this.updatePeekMotion();
          }, { threshold: .01 });
          this.observer.observe(this);
        }
        this.updatePeekMotion();
      }
      disconnectedCallback() {
        this.stopReaction?.();
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
